var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "缩进(字符)" } },
        [
          _c("el-input-number", {
            staticClass: "setting-render_indent",
            attrs: {
              "controls-position": "right",
              placeholder: "请输入缩进字符数量",
              min: 0,
              max: 50
            },
            model: {
              value: _vm.indent,
              callback: function($$v) {
                _vm.indent = _vm._n($$v)
              },
              expression: "indent"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fc9ebab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fc9ebab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/render_setting/RenderIndent.vue
// module id = null
// module chunks = 